import BaseCtrl from 'edge/platform/base/BaseCtrl';

var fn = function fn(ModalService, $location, $window, $scope, PolicyService, CancellationService, $q, $stateParams, $rootScope, MSFConstructionCreditLink, $state) {
    $scope.policyNumber = $stateParams.policyNumber;

    $scope.policyQuoted = false;
    $scope.errorInSubmission = false;
    $rootScope.portalCoveredEmployees = null;
    $scope.locationMissing = false;
    $scope.jobNumber = $stateParams.jobNumber;
    $scope.periodData = {};
    $scope.showWagesTable = false;
    $scope.surveyStartDate = {};
    $scope.surveyEndDate = {};
    /** Dynamic Link Based on URL  **/
    $scope.msfHost = PolicyService.getMsfPortalHost();
    $scope.msfHost.then(function (MSFHost) {
        $scope.docLink = MSFHost + MSFConstructionCreditLink;
    }, function (err) {
        console.error('Error while retrieving MSF host: ', err);
    });

    /**
    * Function to retrieve current Date as set in the backend Server's system clock
    * @ params{void}
    * @ returns{Object} - date - $scope objects day, month and year updated from the response object.
    * @ private
    **/
    var currentDate = PolicyService.getCurrentDate();
    currentDate.then(function (res) {
        var acDate = res;
        $scope.today = new Date(acDate);
        var limit = {};
        limit.day = $scope.today.getDate();
        limit.month = $scope.today.getMonth() - 3;
        limit.year = $scope.today.getFullYear();
        $scope.limitDate = limit;
        var disableLimit = {};
        disableLimit.day = 0;
        disableLimit.month = 0;
        disableLimit.year = $scope.today.getFullYear() - 1;
        $scope.disableLimit = disableLimit;

        var startLimit = {};
        startLimit.day = 1;
        startLimit.month = 6;
        startLimit.year = $scope.today.getFullYear() - 1;
        $scope.startLimit = startLimit;
    });
    /** Listener to update End Date Based on Start Date  **/
    $scope.$watch('surveyStartDate.id', function (newVal, oldVal) {
        var actualDate = new Date($scope.surveyStartDate.id);
        actualDate.setMonth(actualDate.getMonth() + 3);
        var updateEnd = {
            year: actualDate.getFullYear(),
            month: actualDate.getMonth(),
            day: actualDate.getDate()
        };
        $scope.surveyEndDate.id = actualDate;
    });
    /**
     * Function to monitor stateChangeStart event
     * @params{Object, String, String, String, String}
     * @returns{String}
     * @private
     **/
    $rootScope.$on('$stateChangeStart', function (event, toState, toParams, fromState, fromParams) {
        if (toState.name === $rootScope.previousState && toState.name !== 'policies.detail.summary') {
            $state.go('policies.detail.summary', {
                'policyNumber': $stateParams.policyNumber
            });
        } else {
            $rootScope.previousState = fromState.name;
        }
    });

    /**
     * Function to get Construction Credit Data for the given policy change job no and updates Survey start date and end date
     * @params{void}
     * @returns{void} - updates scope variables.
     **/
    $scope.setConstructionCreditWages = function () {
        var start = $scope.surveyEndDate.id.month;var end = $scope.surveyStartDate.id.month;
        var dto = {};
        var actualEndDate = new Date($scope.surveyEndDate.id);
        var actualStartDate = new Date($scope.surveyStartDate.id);
        $scope.surveyStartDate.id = actualStartDate;
        dto.surveyBeginDate = actualStartDate;
        dto.surveyEndDate = actualEndDate;
        $scope.disableWages = true;
        angular.element('#startDate .datetimepicker-icon').css('display', 'none');
        PolicyService.setConstructionCreditWages($scope.jobNumber, dto).then(function (data) {
            $scope.periodData.constructionCreditList = data;
            $scope.showWagesTable = true;
        }, function (res) {
            angular.element('#startDate .datetimepicker-icon').css('display', 'block');
            $scope.disableWages = false;
        });
    };
    /**
    * Function to Get Construction Credit Data for the given policy change job no
    * @params{String} - jobNumber
    * @returns{void}
    * @private
    **/
    PolicyService.getConstructionCreditData($scope.jobNumber).then(function (data) {
        $scope.CCData = data;
        $scope.disableSubmit = false;
        $scope.finalDatArray = [];
        var policyEffDate = new Date($scope.CCData.effectiveDate);
        var surveyEffDate = new Date($scope.CCData.surveyBeginDate);
        var startSelect = new Date(surveyEffDate);
        $scope.surveyStartDate.id = surveyEffDate;

        // Calculating the Immediate Previous Quarter and immediate next quarter
        if ([1, 2, 3].includes(policyEffDate.getMonth() + 1)) {
            var immediatePreQuarEffDate = $scope.calcImmEffDate(policyEffDate, surveyEffDate, '1/1/', '10/1/', -1, 0);
            var immediateNextQuarEffDate = $scope.calcImmEffDate(policyEffDate, surveyEffDate, '7/1/', '4/1/', 0, 0);
        } else if ([4, 5, 6].includes(policyEffDate.getMonth() + 1)) {
            var immediatePreQuarEffDate = $scope.calcImmEffDate(policyEffDate, surveyEffDate, '4/1/', '1/1/', 0, 0);
            var immediateNextQuarEffDate = $scope.calcImmEffDate(policyEffDate, surveyEffDate, '10/1/', '7/1/', 0, 0);
        } else if ([7, 8, 9].includes(policyEffDate.getMonth() + 1)) {
            var immediatePreQuarEffDate = $scope.calcImmEffDate(policyEffDate, surveyEffDate, '7/1/', '4/1/', 0, 0);
            var immediateNextQuarEffDate = $scope.calcImmEffDate(policyEffDate, surveyEffDate, '1/1/', '10/1/', 0, 1);
        } else if ([10, 11, 12].includes(policyEffDate.getMonth() + 1)) {
            var immediatePreQuarEffDate = $scope.calcImmEffDate(policyEffDate, surveyEffDate, '10/1/', '7/1/', 0, 0);
            var immediateNextQuarEffDate = $scope.calcImmEffDate(policyEffDate, surveyEffDate, '4/1/', '1/1/', 1, 1);
        }
        if (immediatePreQuarEffDate) {
            $scope.finalDatArray.push(immediatePreQuarEffDate);
        }
        if (immediateNextQuarEffDate) {
            $scope.finalDatArray.push(immediateNextQuarEffDate);
        }
        $scope.finalDatArray.push(surveyEffDate);
        $scope.dataLoaded = true;
    }, function (res) {
        $scope.disableSubmit = false;
        $scope.errorInSubmission = true;
    });

    /**
     * Method to calculate the Immediate Previous full quarter and Immediate next full quarter
     */
    $scope.calcImmEffDate = function (policyEffDate, surveyEffDate, expDateMonth, effDateMonth, effIncremental, expIncremental) {
        if (new Date(expDateMonth + (policyEffDate.getFullYear() + expIncremental)) <= $scope.today && new Date(effDateMonth + (policyEffDate.getFullYear() + effIncremental)) > surveyEffDate) {
            return new Date(effDateMonth + (policyEffDate.getFullYear() + effIncremental));
        }
    };
    /**
    * Function to withdraw the current transaction. A Modal window with Yes or no option is displayed to user.
    * If yes selected then withdrawPolicyTransaction service called
    * @ params{void}
    * @ returns{boolean} - if resolved, then user is navigated to the Account policy details screen.
    * @ private
    **/
    $scope.withdraw = function () {
        var withdrawModal = ModalService.showConfirm('Confirmation', 'Do you wish to withdraw this transaction?', '', 'withdraw', '', 'Cancel').result;
        withdrawModal.then(function (res) {
            var withdrawPromise = PolicyService.withdrawPolicyTransaction($stateParams.policyNumber, $scope.jobNumber);
            withdrawPromise.then(function (res) {
                $state.go('policies.detail.summary', {
                    'policyNumber': $stateParams.policyNumber
                });
            });
        });
    };

    /**
    *Function to Update Construction Credit, Quotes and Bind Policy Change
    * @params{void}
    * @returns{void}
    * @private
    **/
    $scope.quotePolicyChange = function () {
        PolicyService.updateCoveredEmployees($stateParams.jobNumber, $rootScope.portalCoveredEmployees, $scope.periodData.mSFWCCoveredEmployees).then(function (updatedData) {
            PolicyService.quotePolicyChange($scope.jobNumber).then(function (data) {
                PolicyService.bindPolicyChange($scope.jobNumber).then(function (data) {
                    $rootScope.CCAdded = true;
                    // route to the policy details page to show the confirmation message.
                    $state.go('policies.detail.summary', {
                        'policyNumber': $scope.policyNumber
                    });
                }, function () {
                    $scope.errorInSubmission = true;
                    ModalService.showError('quoteandbind.common.config.FlowConfig.Unable to save submission', 'quoteandbind.common.config.FlowConfig.An error occurred while attempting to save quote submission.');
                });
            }, function () {
                $scope.disableSubmit = false;
                $scope.errorInSubmission = true;
            });
        });
    }; // End Quote PolicyChange
}; // end const
fn.$inject = ['ModalService', '$location', '$window', '$scope', 'PolicyService', 'CancellationService', '$q', '$stateParams', '$rootScope', 'MSFConstructionCreditLink', '$state'];
export default fn;


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/gateway/controllers/ConstructionCreditCtrl.js
// module id = 1668
// module chunks = 0